import React, { createContext, useContext, useState, useEffect } from 'react';
import { auth } from './firebase-config';
import { onAuthStateChanged } from 'firebase/auth';
import { adminServices } from './services/adminServices';

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [staffRecord, setStaffRecord] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      setLoading(true);

      if (firebaseUser) {
        setError(null);
        try {
          const record = await adminServices.syncStaffMember(firebaseUser);
          setUser(firebaseUser);
          setStaffRecord(record);
        } catch (err) {
          console.error("Auth Error:", err);
          setError(err.message || "Sign-in failed. Please contact an IFIP administrator.");
          await adminServices.logout();
          setLoading(false);
          return;
        }
      } else {
        setUser(null);
        setStaffRecord(null);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const login = async () => {
    setLoading(true);
    try {
      await adminServices.login();
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  const logout = () => adminServices.logout();

  const value = {
    user,
    staffRecord,
    permissions: staffRecord?.permissions || {},
    isApproved: staffRecord?.isApproved || false,
    loading,
    error,
    login,
    logout
  };

  return (
    <UserContext.Provider value={value}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) throw new Error("useUser must be used within a UserProvider");
  return context;
};